import { ApiService } from "../../../config";
import {
  IBacklinkImpressions,
  IBacklinkKeywords,
  IBacklinkPostsCount,
  IBacklinkSessions,
  IBacklinkTimeSeries,
  IBacklinkTopPages,
  IResponseDTO,
} from "../types";

const BASE = "/backlink/dashboard";

function paramsFor(customerId?: string) {
  return customerId ? { params: { customerId } } : {};
}

async function fetchMetric<T>(
  path: string,
  customerId?: string
): Promise<T | null> {
  try {
    const result = await ApiService.get(`${BASE}${path}`, paramsFor(customerId));
    const { data, error } = result.data as IResponseDTO<T>;
    if (error) return null;
    return data;
  } catch {
    return null;
  }
}

const getImpressions = (customerId?: string) =>
  fetchMetric<IBacklinkImpressions>("/impressions", customerId);

const getSessions = (customerId?: string) =>
  fetchMetric<IBacklinkSessions>("/sessions", customerId);

const getTimeSeries = (customerId?: string) =>
  fetchMetric<IBacklinkTimeSeries>("/time-series", customerId);

const getKeywords = (customerId?: string) =>
  fetchMetric<IBacklinkKeywords>("/keywords", customerId);

const getTopPages = (customerId?: string) =>
  fetchMetric<IBacklinkTopPages>("/top-pages", customerId);

const getPostsCount = (customerId?: string) =>
  fetchMetric<IBacklinkPostsCount>("/posts-count", customerId);

export const BacklinkDashboardService = {
  getImpressions,
  getSessions,
  getTimeSeries,
  getKeywords,
  getTopPages,
  getPostsCount,
};
